import * as Lucide from "lucide-react";

// Renders a lucide icon by string name from content data.
export const Icon = ({ name, className = "", ...props }) => {
  const Cmp = Lucide[name] || Lucide.Sparkles;
  return <Cmp className={className} {...props} />;
};
